import { render, staticRenderFns } from "./SimpleRadio.vue?vue&type=template&id=ee05a968&"
import script from "./SimpleRadio.vue?vue&type=script&lang=js&"
export * from "./SimpleRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports